import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const propTypes = {
  printable: PropTypes.bool,
};

const defaultProps = {
  printable: true,
};

const PrintAware = styled.div`
  ${({ printable }) =>
    printable &&
    css`
      @media print {
        display: none;
      }
    `}
`;

PrintAware.propTypes = propTypes;
PrintAware.defaultProps = defaultProps;

export default PrintAware;
